import {Graph, Addon} from '@antv/x6'
import EventToolService from './EventToolService'

export default {
    leftMenuInit: function (graph) {
        let stencil = new Addon.Stencil({
            title: 'title',
            target: graph,
            stencilGraphWidth: 180,
            stencilGraphHeight: 180,
            collapsable: true,  //是否显示全局折叠/展开按钮。
            groups: [
                {
                    title: '',
                    name: 'group1',
                    collapsable: false, //分组是否可折叠，默认为 true
                    graphHeight: 90 * 2,  // 模板画布高度
                    layoutOptions: {
                        columns: 2,
                        columnWidth: 80,
                        rowHeight: 90,
                        //dx: 0,  //单元格在 X 轴的偏移量，默认为 10。
                        dy: 0,  //单元格在 Y 轴的偏移量，默认为 10。
                        marginX: 0,  //单元格在 X 轴的边距，默认为 0。  距离左侧
                        marginY: 0 //单元格在 Y 轴的边距，默认为 0   距离顶部
                    },
                },
                {
                    title: '',
                    name: 'group2',
                    collapsable: false, //分组是否可折叠，默认为 true
                    graphHeight: 90 * 3,  // 模板画布高度
                    layoutOptions: {
                        columns: 1,
                        columnWidth: 76 * 2,
                        rowHeight: 90,
                        dx: (180 - 76 * 2) / 2,  //单元格在 X 轴的偏移量，默认为 10。
                        dy: 0,  //单元格在 Y 轴的偏移量，默认为 10。
                        marginX: 0,  //单元格在 X 轴的边距，默认为 0。  距离左侧
                        marginY: 0 //单元格在 Y 轴的边距，默认为 0   距离顶部
                    },
                },
                {
                    title: '',
                    name: 'group3',
                    collapsable: false, //分组是否可折叠，默认为 true
                    graphHeight: 90 * 2 / 3,  // 模板画布高度
                    layoutOptions: {
                        columns: 2,
                        columnWidth: 80,
                        rowHeight: 90 * 2 / 3,
                        //dx: 0,  //单元格在 X 轴的偏移量，默认为 10。
                        dy: 0,  //单元格在 Y 轴的偏移量，默认为 10。
                        marginX: 0,  //单元格在 X 轴的边距，默认为 0。  距离左侧
                        marginY: 0 //单元格在 Y 轴的边距，默认为 0   距离顶部
                    },
                },
            ],
        })

        //栏目挂载
        document.getElementById("leftTool").appendChild(stencil.container)

        //装载模板节点
        this.stencilLoad(graph, stencil)
    },
    stencilLoad: function (graph, stencil) {
        // 初始化图形
        let nodes = EventToolService.nodes()

        //注册节点
        nodes.forEach((item) => {
            Graph.registerNode(
                item.name,
                {
                    inherit: 'rect',
                    width: item.width,
                    height: item.height,
                    attrs: {
                        body: {
                            strokeWidth: 1,
                            stroke: item.stroke, //边颜色
                            fill: item.color,
                        },
                        text: {
                            fontSize: 12,
                            lineHeight: 17,
                            fill: '#262626',
                        },
                    },
                },
                true,
            )
        })

        let nodesLeft1 = [
            {id: 'node1', label: 'Read Model\n读取模型', type: 'model', x: 0, y: 0,},
            {id: 'node2', label: 'Commamd\n命令', type: 'commamd', x: 86, y: 0,},
            {id: 'node3', label: 'Event\n领域事件', type: 'event', x: 0, y: 86,},
            {id: 'node4', label: 'Waring\n问题|警告', type: 'waring', x: 86, y: 86,},
        ]
        let nodesLeft2 = [
            {id: 'node5', label: 'System\n外部系统', type: 'system', x: 11, y: 172,},
            {id: 'node6', label: 'Policy\n规则', type: 'policy', x: 11, y: 258,},
            {id: 'node7', label: 'aggregate\n聚合', type: 'aggregate', x: 11, y: 258,},
        ]
        let nodesLeft3 = [
            {id: 'node8', label: 'User\n用户', type: 'role', x: 11, y: 344,},
            {id: 'node9', label: 'text', type: 'textNode', x: 60, y: 344,},
        ]

        let group1Nodes = []
        nodesLeft1.forEach((item) => {
            const r1 = graph.createNode({
                shape: item.type,
                label: item.label,
                attrs: {},
            })
            group1Nodes.push(r1)
        })
        stencil.load(group1Nodes, 'group1')

        let group2Nodes = []
        nodesLeft2.forEach((item) => {
            const r2 = graph.createNode({
                shape: item.type,
                label: item.label,
                attrs: {},
            })
            group2Nodes.push(r2)
        })
        stencil.load(group2Nodes, 'group2')

        let group3Nodes = []
        nodesLeft3.forEach((item) => {
            const r1 = graph.createNode({
                shape: item.type,
                label: item.label,
            })
            group3Nodes.push(r1)
        })
        stencil.load(group3Nodes, 'group3')
    },
}